module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register_client"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-stack2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s((_vm.actionType == "reg") ? _vm.registerLan.crumbs.newaAccount : _vm.registerLan.crumbs.amend))])]), _vm._v(" "), _c('div', {
    staticClass: "content_box"
  }, [_c('h2', [_vm._v(_vm._s(_vm.registerLan.sales.title))]), _vm._v(" "), _c('div', {
    staticClass: "inputBox"
  }, [_c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.sales_id,
      "errBool": _vm.errors.has('sales_id'),
      "errTexrt": _vm.registerLan.flaseTipNum
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:11'),
      expression: "'required|numeric|max:11'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.sales_id),
      expression: "formMsgArr.sales_id"
    }],
    ref: "sales_id",
    staticClass: "form-control col-lg-12",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('sales_id')
    },
    attrs: {
      "name": "sales_id",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formMsgArr.sales_id)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "sales_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user_id_point),
      expression: "user_id_point"
    }],
    staticClass: "errText-wrapper"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle errText"
  }, [_vm._v(_vm._s(_vm.registerLan.user_id_point))])])]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.acc_name,
      "errBool": _vm.errors.has('user_name'),
      "errTexrt": _vm.registerLan.flaseTipName
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:45'),
      expression: "'required|max:45'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.user_name),
      expression: "formMsgArr.user_name"
    }],
    ref: "user_name",
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "user_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formMsgArr.user_name)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "user_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user_name_point),
      expression: "user_name_point"
    }],
    staticClass: "errText-wrapper"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle errText"
  }, [_vm._v(_vm._s(_vm.registerLan.user_name_point))])])]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.password,
      "errBool": _vm.errors.has('password'),
      "errTexrt": _vm.registerLan.flaseTipPass
    }
  }, [(_vm.actionType == 'reg') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_dash|min:1|max:256'),
      expression: "'required|alpha_dash|min:1|max:256'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.password),
      expression: "formMsgArr.password"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.formMsgArr.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.actionType == 'change') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('alpha_dash|min:1|max:256'),
      expression: "'alpha_dash|min:1|max:256'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.password),
      expression: "formMsgArr.password"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.formMsgArr.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "password", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.phone,
      "errBool": _vm.errors.has('phone'),
      "errTexrt": _vm.registerLan.flasePhone
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num|max:255'),
      expression: "'required|alpha_num|max:255'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.phone),
      expression: "formMsgArr.phone"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.formMsgArr.phone)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.email,
      "errBool": _vm.errors.has('email'),
      "errTexrt": _vm.registerLan.flaseTip
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.email),
      expression: "formMsgArr.email"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.formMsgArr.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "email", $event.target.value)
      }, _vm.validate_email]
    }
  }), _vm._v(" "), (_vm.is_repeat_email) ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.registerLan.email_isRepeat))]) : _vm._e()]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales_info.form.jurisdiction.name
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.jurisdictionActive),
      expression: "jurisdictionActive"
    }],
    staticClass: "dfinput form-control col-lg-12",
    attrs: {
      "name": "qx"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jurisdictionActive = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectChange('jurisdictionActive')
      }]
    }
  }, _vm._l((_vm.jurisdictions), function(item, index) {
    return _c('option', {
      domProps: {
        "value": _vm.jurisdictions[index]
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('qx')),
      expression: "errors.has('qx')"
    }],
    staticClass: "help-block"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle false"
  }, [_vm._v(_vm._s(_vm.registerLan.flaseTip))])])]), _vm._v(" "), _c('mimput', {
    staticClass: "col-lg-6",
    attrs: {
      "col": 12,
      "label": _vm.registerLan.sales.form.remark
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formMsgArr.remark),
      expression: "formMsgArr.remark"
    }],
    staticClass: "form-control col-lg-12",
    attrs: {
      "name": "remark",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formMsgArr.remark)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFn.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formMsgArr, "remark", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn bg-teal",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v(_vm._s(_vm.actionType == "reg" ? _vm.registerLan.submit : _vm.registerLan.changeBtn))])])]), _vm._v(" "), _c('Modal', {
    staticClass: "modal-content-j",
    attrs: {
      "size": "sm",
      "header": false,
      "footer": false,
      "backdrop": !_vm.modalLink
    },
    on: {
      "hide": _vm.toModalLink
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    class: (_vm.modalBool ? 'color-green' : 'color-red')
  }, [_c('i', {
    staticClass: "glyphicon",
    class: (_vm.modalBool ? 'glyphicon-ok' : 'glyphicon-warning-sign')
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.modalBool ? _vm.registerLan.submitResult.succeed : _vm.registerLan.submitResult.err))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalLink),
      expression: "modalLink"
    }],
    staticClass: "btn btn-success btn-xs",
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    }
  }, [_vm._v(_vm._s(_vm.registerLan.logOut.yes))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fedf468","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userDatum.vue
// module id = 1126
// module chunks = 1